import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  activeStatus: {
    color: theme.palette.success.main,
    textTransform: 'capitalize',

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  headerButton: {
    textTransform: 'inherit',
    marginLeft: 10,
  },
}));

export default useStyles;
